import styles from "./ListToolbar.module.css";

function ListToolbar({ search, onSearchChange, typeFilter, onTypeChange, typeOptions, allTypesLabel = "전체 출판유형", dateFrom, onDateFromChange, dateTo, onDateToChange, placeholder="검색..." }) {
    return (
        <div className={styles.toolbar}>
            <input
                className={styles.searchInput}
                type="text"
                placeholder={placeholder}
                value={search}
                onChange={e => onSearchChange(e.target.value)}
            />
            {typeOptions && (
                <select
                    className={styles.select}
                    value={typeFilter}
                    onChange={e => onTypeChange(e.target.value)}
                >
                    <option value="">{allTypesLabel}</option>
                    {typeOptions.map((opt, i) => {
                        // Supports plain strings or { value, label } pairs.
                        const value = typeof opt === "object" ? opt.value : opt;
                        const label = typeof opt === "object" ? opt.label : opt;
                        return <option key={i} value={value}>{label}</option>;
                    })}
                </select>
            )}
            <input
                className={styles.dateInput}
                type="date"
                value={dateFrom}
                onChange={e => onDateFromChange(e.target.value)}
            />
            <span className={styles.dateSeparator}>~</span>
            <input
                className={styles.dateInput}
                type="date"
                value={dateTo}
                onChange={e => onDateToChange(e.target.value)}
            />
        </div>
    );
}

export default ListToolbar;